import React from "react";
import { Navigate } from "react-router-dom";
import { useLoadDoctype } from "../../shared/hooks/useFrappeDoctype";
import { useGetLoggedUser } from "../../shared/hooks/useUser";

const LoginProtected = ({ children }) => {
    const { data: loggedUser, status, isFetching } = useGetLoggedUser(true);
    const { data: restaurantSettings, status: restaurantSettingsStatus } =
        useLoadDoctype(
            "Restaurant Settings",
            "Restaurant Settings"
        );

    const loggedIn =
        status === "success" &&
        !!loggedUser?.user_type &&
        loggedUser.user_type !== "Website User";
    const kdsRoleProfile =
        restaurantSettings?.docs?.[0]?.kds_production_center?.trim?.();
    const kitchenRedirectTarget = kdsRoleProfile
        ? `/kds/${encodeURIComponent(kdsRoleProfile)}`
        : "/kds";

    if (status === "loading" || isFetching) return null;
    if (loggedIn) {
        const isKitchen = loggedUser?.role_profile_name === "Kitchen";

        if (isKitchen && restaurantSettingsStatus === "loading") {
            return null;
        }

        return (
            <Navigate
                to={isKitchen ? kitchenRedirectTarget : "/tables"}
                replace
            />
        );
    }
    return children;
};

export default LoginProtected;
